import { render, staticRenderFns } from "./Forms.vue?vue&type=template&id=124c1854&"
import script from "./Forms.vue?vue&type=script&lang=js&"
export * from "./Forms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports